import { ApiErrorResponseSchema } from "@herskin/contracts";

export class ApiError extends Error {
  constructor(
    message: string,
    readonly code: string,
    readonly errorId: string,
    readonly status?: number,
  ) {
    super(message);
  }
}

/** 所有副作用请求都带同源标记；浏览器 Cookie 由 HttpOnly 策略自动管理。 */
export async function api<T>(pathname: string, options: RequestInit = {}): Promise<T> {
  let response: Response;
  try {
    response = await fetch(pathname, {
      ...options,
      credentials: "same-origin",
      headers: {
        ...(options.body ? { "Content-Type": "application/json" } : {}),
        ...(options.method && options.method !== "GET" ? { "X-HerSkin-Request": "1" } : {}),
        ...options.headers,
      },
    });
  } catch {
    // fetch 不区分 DNS、断网或连接中止；不向界面泄露浏览器内部异常文本。
    throw new ApiError("网络连接中断，请稍后重新检查请求状态", "NETWORK_ERROR", "err_network");
  }
  const body = (await response.json().catch(() => null)) as unknown;
  if (!response.ok) {
    const parsed = ApiErrorResponseSchema.safeParse(body);
    if (parsed.success) {
      throw new ApiError(
        parsed.data.error.message,
        parsed.data.error.code,
        parsed.data.error.errorId,
        response.status,
      );
    }
    // 反代、网关或上游偶尔返回 HTML；只呈现状态码，绝不回显响应正文。
    throw new ApiError(
      `上游返回非标准错误（HTTP ${response.status}）`,
      "HTTP_ERROR",
      `err_http_${response.status}`,
      response.status,
    );
  }
  return body as T;
}
